import { z } from 'zod';

// Grouped Data Schema
export const DashboardGroupedDataResponseSchema = z.object({
  purchases: z.array(
    z.object({
      _id: z.object({
        day: z.number(),
        month: z.number(),
        year: z.number(),
      }),
      totalPurchases: z.number(),
      count: z.number(),
    }),
  ),
  usersByProduct: z.array(
    z.object({
      productName: z.string(),
      userCount: z.number(),
    }),
  ),
  usersByPlatform: z.array(
    z.object({
      _id: z.string(), // Platform name
      userCount: z.number(),
    }),
  ),
  usersByHostApp: z.array(
    z.object({
      _id: z.string(), // Host App name
      userCount: z.number(),
    }),
  ),
});

export type DashboardGroupedDataResponse = z.infer<
  typeof DashboardGroupedDataResponseSchema
>;

// Recent Users Schema
export const RecentUsersResponseSchema = z.object({
  docs: z.array(
    z.object({
      firstName: z.string(),
      lastName: z.string(),
      email: z.string(),
      lastLogin: z.string(),
    }),
  ),
  totalDocs: z.number(),
  limit: z.number(),
  page: z.number(),
  totalPages: z.number(),
  hasNextPage: z.boolean(),
  hasPrevPage: z.boolean(),
});

export type RecentUsersResponse = z.infer<typeof RecentUsersResponseSchema>;

export const RecentUsersRequestSchema = z.object({
  page: z.number().optional(),
  limit: z.number().optional(),
});

export type RecentUsersRequest = z.infer<typeof RecentUsersRequestSchema>;

// Refunds Schema
export const RefundsResponseSchema = z.object({
  docs: z.array(
    z.object({
      transactionId: z.string(),
      amount: z.number(),
      status: z.string().optional(),
      note: z.string().optional(),
    }),
  ),
  totalDocs: z.number(),
  limit: z.number(),
  page: z.number(),
  totalPages: z.number(),
  hasNextPage: z.boolean(),
  hasPrevPage: z.boolean(),
});

export type RefundsResponse = z.infer<typeof RefundsResponseSchema>;

export const RefundsRequestSchema = z.object({
  page: z.number().optional(),
  limit: z.number().optional(),
});

export type RefundsRequest = z.infer<typeof RefundsRequestSchema>;
